/* Dansk katalog for locale-closing-tax-no.js (del 1 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'clo.close': 'Luk',
  'clo.change': 'Ændr',
  'clo.save': 'Gem',
  'clo.cancel': 'Annuller',
  'clo.showDetails': 'Vis detaljer',
  'clo.sum': 'Sum',
  'clo.addAsset': 'Tilføj anlægsaktiv',
  'clo.no': 'Nej',
  'clo.delete': 'Slet',
  'clo.details': 'Detaljer',
  'clo.addedByUser': 'Tilføjet af bruger',
  'clo.removeChange': 'Fjern ændring',
  'clo.done': 'Færdig',
  'clo.required': 'Påkrævet',
  'clo.seeDetails': 'se detaljer',
  'clo.searchAccounts': 'Søg i konti',
  'clo.noMatches': 'Ingen resultater',
  'clo.searchShort': 'Søg …',
  'clo.addValue': 'Tilføj værdi',
  'clo.pick': 'Vælg',
  'clo.changed': 'Ændret',
  'clo.override': 'Tilsidesæt',
  'clo.add': 'Tilføj',
  'clo.type': 'Type',
  'clo.amount': 'Beløb',
  'clo.wealthValue': 'Formueværdi',
  'clo.totalReportableBenefit': 'Samlet oplysningspligtig ydelse',
  'clo.autoCalculated': 'Beregnes automatisk',
  'clo.valueType': 'Værditype',
  'clo.bookValue': 'Regnskabsmæssig værdi',
  'clo.taxValue': 'Skattemæssig værdi',
  'clo.inventoryTotal': 'Samlet værdi af varelager',
  'clo.inventorySpec': 'Specifikation af varelager',
  'clo.equityChange': 'Egenkapitalændring',
  'clo.equityChangeType': 'Type af egenkapitalændring',
  'clo.principleChange': 'Principændring',
  'clo.plBalanceType': 'Type af resultatopgørelse og balance',
  'clo.cannotChange': 'Kan ikke ændres',
  'clo.description': 'Beskrivelse',
  'clo.openingEquity': 'Primo egenkapital',
  'clo.equityChanges': 'Egenkapitalændringer',
  'clo.profitLossForYear': 'Årets overskud/underskud',
  'clo.principleChanges': 'Principændringer',
  'clo.closingEquity': 'Ultimo egenkapital',
  'clo.addEquityChange': 'Tilføj egenkapitalændring',
  'clo.addPrincipleChange': 'Tilføj principændring',
  'clo.principleChangeHelp': 'Vælg den regnskabskonto, som principændringen vedrører. Beløbene gemmes kun i udkastet til skattemeldingen.',
  'clo.employerTaxBenefit': 'Samlet arbejdsgiverafgiftspligtig ydelse',
  'clo.accountNumber': 'Kontonummer',
  'clo.accountName': 'Kontonavn',
  'clo.reportableSalaryBenefit': 'Lønoplysningspligtig ydelse',
  'clo.employerTaxBenefitShort': 'Arbejdsgiverafgiftspligtig ydelse',
  'clo.detailedPayrollCost': 'Detaljeret løn- og pensionsomkostning',
  'clo.detailedPayrollHelp': 'Indtast den skattemæssige specifikation pr. konto. Oplysningerne gemmes kun i udkastet til skattemeldingen.',
  'clo.addDetailedPayroll': 'Tilføj detaljeret løn- og pensionsomkostning',
  'clo.noTempDiffsShort': 'Ingen midlertidige forskelle registreret',
  'clo.changeVerb': 'ændr',
  'clo.lastYear': 'Sidste år',
  'clo.thisYear': 'I år',
  'clo.movement': 'Ændring',
  'clo.bookValueHelp': 'Værdien, som den er bogført efter regnskapslovens regler — f.eks. baseret på historisk kostpris minus regnskabsmæssige afskrivninger.',
  'clo.taxValueHelp': 'Værdien, som den beregnes efter skattelovens regler — f.eks. baseret på saldoafskrivning. Afviger ofte fra den regnskabsmæssige værdi.',
  'clo.difference': 'Forskel',
  'clo.differenceHelp': 'Differencen mellem regnskabsmæssig og skattemæssig værdi. Denne forskel udlignes over tid og påvirker skattegrundlaget. Ændringen i årets forskel lægges til eller trækkes fra i beregningen af årets skattegrundlag.',
  'clo.permanentDiff': 'Permanent forskel',
  'clo.permanentDiffType': 'Type af permanent forskel',
  'clo.additionToBusinessIncome': 'Tillæg i erhvervsindkomst',
  'clo.deductionFromBusinessIncome': 'Fradrag i erhvervsindkomst',
  'clo.optionalDescription': 'Valgfri beskrivelse',
  'clo.temporaryDiff': 'Midlertidig forskel',
  'clo.temporaryDiffType': 'Type af midlertidig forskel',
  'clo.bookValuePrevYear': 'Regnskabsmæssig værdi forrige indkomstår',
  'clo.taxValuePrevYear': 'Skattemæssig værdi forrige indkomstår',
  'clo.diffMovement': 'Ændring i forskel',
  'clo.back': 'Tilbage',
  'clo.calculation': 'Beregning',
  'clo.taxBase': 'Skattegrundlag',
  'clo.lossCarryforward': 'Underskud til fremførsel',
  'clo.deferredTaxOrAsset': 'Udskudt skat / skatteaktiv',
  'clo.permanentDiffs': 'Permanente forskelle',
  'clo.noPermanentDiffs': 'Ingen permanente forskelle registreret.',
  'clo.temporaryDiffs': 'Midlertidige forskelle',
  'clo.noTemporaryDiffs': 'Ingen midlertidige forskelle registreret.',
  'clo.additionalSpecs': 'Tillægsspecifikationer',
  'clo.assetsAndInventory': 'Aktiver og varelager',
  'clo.sharesAndInvestments': 'Aktier og investeringer',
  'clo.otherWealth': 'Anden formue',
  'clo.debt': 'Gæld',
  'clo.objectIdentifier': 'Objekt-id',
  'clo.basis': 'Grundlag',
  'clo.closingValue': 'Ultimoværdi',
  'clo.noAssetsRegistered': 'Ingen anlægsaktiver eller gevinst-/tabskonti registreret.',
  'clo.otherCompanyInfo': 'Andre selskabsoplysninger',
  'clo.investments': 'Investeringer',
  'clo.noInvestments': 'Ingen investeringer registreret.',
  'clo.incomeStatement': 'Resultatopgørelse',
  'clo.operatingIncome': 'Driftsindtægt',
  'clo.operatingCost': 'Driftsomkostning',
  'clo.balanceSheet': 'Balance',
  'clo.totalAssets': 'Aktiver i alt',
  'clo.totalEquity': 'Egenkapital i alt',
  'clo.totalDebt': 'Gæld i alt',
  'clo.totalEquityAndDebt': 'Egenkapital og gæld i alt',
  'clo.manualAdditions': 'Manuelle tillæg i udkastet til skattemeldingen',
  'clo.additionalItems': 'Tillægsposter',
  'clo.specifications': 'Specifikationer',
  'clo.taxReturnLead': 'Skattemeldingen for selskabet bygger på regnskabet. Plumme laver et foreløbigt udkast til skattegrundlag, formue og gæld.',
  'clo.aboutTaxReturn': 'Om skattemeldingen',
  'clo.aboutTaxReturnHelp': 'Plumme bygger skattemeldingen på dit regnskab. Du gennemgår hvert trin, kontrollerer tallene og indsender. Senere hentes og indberettes tal direkte til Skatteetaten og Altinn.',
  'clo.incomeYear': 'Indkomstår',
  'clo.incomeYearHelp': 'Det regnskabsår, skattemeldingen gælder for. Skift år øverst til højre i appen, hvis du skal arbejde med et andet år.',
  'clo.financialYear': 'Regnskabsåret',
  'clo.calculatedTax': 'Beregnet skat',
  'clo.calculatedTaxHelp': 'Foreløbig skat, som Plumme beregner ud fra skattegrundlaget (overskud justeret for permanente og midlertidige forskelle) ganget med skattesatsen. Er resultatet negativt, bliver det 0, og underskuddet fremføres.',
  'clo.lossCarryforwardHelp': 'Et skattemæssigt underskud i år kan fratrækkes i overskud i senere år. Dette beløb gemmes og bruges automatisk, næste gang du har overskud.',
  'clo.toNextYear': 'Til næste år',
  'clo.fetchAndCreateDraft': 'Hent oplysninger og opret udkast',
  'clo.fetchAndCreateDraftHelp': 'I dag bygger Plumme udkastet på de tal, du selv har bogført i regnskabet. Hentning af forudfyldte tal direkte fra Skatteetaten og Altinn kommer senere — indtil videre oprettes udkastet lokalt. Derefter gennemgår du hvert trin, kontrollerer og indsender.',
  'clo.checkContactInfo': 'Tjek kontaktoplysninger',
  'clo.checkContactInfoHelp': 'Den kontaktperson, Skatteetaten bruger, hvis de har spørgsmål til din skattemelding. Hentes fra Plumme-brugeren, men kan ændres her.',
  'clo.name': 'Navn',
  'clo.phone': 'Telefonnummer',
  'clo.email': 'E-mailadresse',
  'clo.mobile': 'Mobilnummer',
  'clo.editContactInfo': 'Ændr kontaktoplysninger',
  'clo.hasAuditor': 'Har virksomheden en revisor?',
  'clo.hasAuditorHelp': 'Revisionspligtige selskaber skal have skattemeldingen godkendt af en registreret revisor før indsendelse. De fleste små AS er ikke revisionspligtige, så længe de holder sig under grænseværdierne for omsætning, balancesum og ansatte.',
  'clo.auditorConfirms': 'Skattemeldingen skal bekræftes af revisor',
  'clo.filingDetails': 'Oplysninger om indsendelsen',
  'clo.taxpayer': 'Skattepligtig',
  'clo.filer': 'Indsender',
  'clo.contactInfo': 'Kontaktoplysninger',
  'clo.accountingPeriod': 'Regnskabsperiode',
  'clo.annualAccountsRuleType': 'Regeltype for årsregnskab',
  'clo.annualAccountsRuleTypeHelp': 'Hvilket regelsæt årsregnskabet udarbejdes efter. Små virksomheder (under visse grænser for omsætning, balance og ansatte) kan bruge forenklede regler. IFRS er internationale standarder, der primært er relevante for større/børsnoterede selskaber.',
  'clo.auditorApproval': 'Skal skattemeldingen godkendes af revisor',
  'clo.taxBaseHelp': 'Det beløb, skatten beregnes af. Tager udgangspunkt i det regnskabsmæssige resultat, korrigeret for permanente og midlertidige forskelle og eventuelt fremført underskud. Kaldes også alminnelig inntekt.',
  'clo.taxRate': 'Skattesats',
  'clo.taxRateHelp': 'Den procentsats, skatten beregnes med. For aktieselskaber er den almindelige selskabsskat 22 % af skattegrundlaget.',
  'clo.taxPayable': 'Betalbar skat',
  'clo.taxPayableHelp': 'Den skat, selskabet faktisk skal betale for året: skattegrundlag × skattesats. Er grundlaget negativt (underskud), bliver den betalbare skat 0, og underskuddet fremføres.',
  'clo.wealthAndDebt': 'Formue og gæld',
  'clo.wealth': 'Formue',
  'clo.totalWealthAndDebt': 'Samlet formue og gæld fra erhverv',
  'clo.netWealthHelp': 'Nettoformue: formue minus gæld. Danner grundlag for ejernes formueskat. Et AS kan ikke have negativ nettoformue — så indberettes 0 kr.',
  'clo.checkTempDiffsLastYear': 'Tjek midlertidige forskelle fra sidste år',
  'clo.checkTempDiffsHelp': 'Primoværdier (01.01) for midlertidige forskelle og fremførbart underskud skal stemme med sidste års skattemelding. Afvigelser skal rettes, før du går videre.',
  'clo.tempDiffsAtOpening': 'Midlertidige forskelle pr. 01.01',
  'clo.tempDiffsAtOpeningHelp': 'Summen af midlertidige forskelle ved årets start — hentet fra sidste års skattemelding. Skal stemme med ultimoværdien sidste år.',
  'clo.lossCarryforwardAtOpening': 'Fremførbart underskud pr. 01.01',
  'clo.lossCarryforwardAtOpeningHelp': 'Uudnyttet skattemæssigt underskud fra tidligere år, som tages med ind i året og kan modregnes i årets overskud.',
  'clo.profitBeforeTax': 'Resultat før skat',
  'clo.profitBeforeTaxHelp': 'Regnskabsmæssigt overskud eller underskud før skatteudgift — alle indtægter minus alle omkostninger, som de står i regnskabet.',
  'clo.permanentDiffsExTax': 'Permanente forskelle ekskl. skat',
  'clo.permanentDiffsExTaxHelp': 'Indtægter, der er skattefri, eller omkostninger uden fradragsret. Disse forsvinder aldrig — de påvirker skatten i år og tilbageføres ikke senere (f.eks. ikke-fradragsberettiget repræsentation).',
  'clo.tempDiffMovement': 'Ændring i midlertidig forskel',
  'clo.tempDiffMovementHelp': 'Årets ændring i forskelle mellem regnskab og skat, som udlignes over tid (f.eks. forskellige afskrivninger). Forskyder, hvornår skatten betales, men ikke det samlede beløb.',
  'clo.priorLossUsedHelp': 'Tidligere års underskud, der bruges til at reducere årets skattegrundlag.',
  'clo.taxBaseResultHelp': 'Resultatet af korrektionerne ovenfor — det beløb, skatten faktisk beregnes af. Kaldes også alminnelig inntekt.',
  'clo.corporateRateHelp': 'Almindelig selskabsskattesats for aktieselskaber.',
  'clo.taxToPayHelp': 'Den skat, der skal betales: skattegrundlag × 22 %. Bliver 0 ved underskud.',
  'clo.deferredTaxCalc': 'Beregning af udskudt skat / udskudt skatteaktiv',
  'clo.deferredTaxBasisHelp': 'Samlede forskelle mellem regnskabsmæssige og skattemæssige værdier, som vil blive udlignet i fremtiden.',
  'clo.lossCarryforwardShort': 'Fremførbart underskud',
  'clo.lossCarryforwardShortHelp': 'Uudnyttet underskud, der kan modregnes i fremtidigt overskud.',
  'clo.unrecognisedDeferredAsset': 'Ikke-bogført udskudt skatteaktiv',
  'clo.deferredTaxBasis': 'Grundlag for beregning af udskudt skat',
  'clo.deferredTax': 'Udskudt skat',
  'clo.deferredTaxHelp': 'Skat, der hører til året, men først betales senere (udskudt skat) — eller en fremtidig skattebesparelse (udskudt skatteaktiv). Vises i balancen, ikke som betalbar skat nu.',
  'clo.permanentDiffsHelp': 'Indtægter, der er skattefri, eller omkostninger, der ikke giver fradragsret — for altid, ikke kun midlertidigt. Eksempel: udbytte under fritaksmetoden, ikke-fradragsberettiget repræsentation eller bøder. Lægges til (tillæg) eller trækkes fra (fradrag) det regnskabsmæssige resultat for at nå frem til skattegrundlaget.',
  'clo.addPermanentDiffItem': 'Tilføj post for permanent forskel',
  'clo.addPermanentDiffItemHelp': 'Tilføj indtægter, der er skattefri, eller omkostninger uden fradragsret, som ikke allerede er hentet automatisk. Vælg type, og indtast beløbet.',
  'clo.addPermanentDiff': 'Tilføj permanent forskel',
  'clo.temporaryDiffsHelp': 'Forskelle mellem regnskabsmæssige og skattemæssige værdier, som udlignes over tid. F.eks. er afskrivningssatserne forskellige i regnskapsloven og skatteloven, hvilket giver forskellig omkostning hvert år — men den samlede omkostning bliver den samme. Ændring i midlertidig forskel påvirker, hvornår skatten betales, ikke den samlede skattebyrde.',
  'clo.addTempDiffItem': 'Tilføj post for midlertidig forskel',
  'clo.addTempDiffItemHelp': 'Midlertidige forskelle, som Plumme ikke har hentet automatisk, kan tilføjes manuelt her. Vælg post (konto/aktivtype), og indtast regnskabsmæssig og skattemæssig værdi.',
  'clo.addTempDiff': 'Tilføj midlertidig forskel',
  'clo.lossCarryforwardLongHelp': 'Skattemæssigt underskud fra ét år kan overføres til fremtidige år og bruges til at reducere skattegrundlaget, når selskabet har overskud. Der er ingen tidsbegrænsning på fremførsel af underskud i Norge — det kan bruges, så længe der er overskud at modregne i.',
  'clo.priorLossCarried': 'Fremført underskud fra tidligere år',
  'clo.priorLossCarriedHelp': 'Akkumuleret skattemæssigt underskud fra år før dette år. Beløbet overføres automatisk fra sidste års skattemelding.',
  'clo.debtSettlement': 'Opnået frivillig akkord og gældseftergivelse',
  'clo.debtSettlementHelp': 'Hvis kreditor eftergiver gæld under en frivillig akkord, kan det reducere det fremførbare underskud. Tidligere også kaldet underhåndsakkord. Påvirker ikke beregningen i Plumme – før det i skattemeldingen hos Skatteetaten.',
  'clo.debtSettlementRest': 'Rest af opnået frivillig akkord og gældseftergivelse',
  'clo.debtSettlementRestHelp': 'Eventuelt resterende gældseftergivelsesbeløb, som endnu ikke er brugt til at reducere underskuddet.',
  'clo.lossUsedThisYear': 'Årets anvendelse af fremført underskud fra tidligere år',
  'clo.lossUsedThisYearHelp': 'Hvor meget af det fremførte underskud, der bruges til at modregne i årets overskud. Må ikke overstige årets skattegrundlag (før denne post).',
  'clo.lossCarryforwardInIncome': 'Fremførbart underskud i indkomst',
  'clo.lossCarryforwardInIncomeHelp': 'Resulterende fremførbart underskud til næste år: forrige saldo minus årets anvendelse plus eventuelt nyt underskud.',
  'clo.addSpecification': 'Tilføj specifikation',
  'clo.overview': 'Oversigt',
  'clo.notCalculatedInPlumme': 'Påvirker ikke beregningen i Plumme – før det i skattemeldingen hos Skatteetaten.',
  'clo.taxAssetsNotCalculated': 'Aktiver, du tilføjer manuelt her, påvirker ikke beregningen i Plumme – før dem i skattemeldingen hos Skatteetaten. Kun driftsmidler fra aktivregistret indgår i skattegrundlaget.',
  'clo.notCalculatedTitle': 'Beregnet skat skal afklares.',
  'clo.notCalculatedBody': 'Udkastet indeholder oplysninger, der ikke indgår i Plummes skatteberegning: {{items}}. Før dem i skattemeldingen hos Skatteetaten, og få skatten kontrolleret af en bogholder.',
  'clo.notCalculatedInput.groupContribution': 'koncernbidrag',
  'clo.notCalculatedInput.skattefunn': 'SkatteFUNN',
  'clo.notCalculatedInput.foreignTaxCredit': 'fradrag for skat betalt i udlandet',
  'clo.notCalculatedInput.foreignSubsidiaryTaxCredit': 'fradrag for skat af udbytte fra udenlandsk datterselskab',
  'clo.notCalculatedInput.foreignTaxReversal': 'tilbageført udenlandsk skat',
  'clo.notCalculatedInput.debtForgiveness': 'underhåndsakkord og gældseftergivelse',
  'clo.notCalculatedInput.manualTaxAssets': 'manuelt tilføjede aktiver',
  'clo.taxProvisionStaleTitle': 'Bogført skat er forældet.',
  'clo.taxProvisionStaleBody': 'Skattegrundlaget er ændret, efter at året blev lukket. Bogført betalbar skat er {{booked}}, mens udkastet nu giver {{current}}. Genåbn året, og luk det igen, før skattemeldingen eller årsregnskabet indsendes.',
  'clo.lossUsedThisYearCalculatedHelp': 'Beregnes automatisk for aktieselskaber: fremført underskud bruges mod årets positive skattegrundlag, så langt det rækker, og anvendelsen kan ikke udskydes.',
  'clo.aiTaxAssetSaved': 'Aktivet er føjet til aktivspecifikationen i udkastet. Det påvirker ikke skatteberegningen i Plumme – før det i skattemeldingen hos Skatteetaten.',
  'clo.contactInfoSaved': 'Kontaktoplysninger gemt',
  'clo.taxDraftSaveFailed': 'Kunne ikke gemme udkastet til skattemelding.',
  'clo.taxBasisSaveFailed': 'Kunne ikke gemme skattegrundlaget.',
  'clo.itemAdded': '{{title}} tilføjet',
  'clo.permanentDiffSaved': 'Permanent forskel gemt',
  'clo.entryDeleted': 'Posten blev slettet',
  'clo.temporaryDiffSaved': 'Midlertidig forskel gemt',
  'clo.specificationRemoved': 'Specifikation fjernet',
  'clo.taxAssetSaveFailed': 'Kunne ikke gemme aktivspecifikationen.',
  'clo.assetSaved': '{{title}} gemt',
  'clo.assetFallback': 'Aktiv',
  'clo.objectDeleted': 'Objektet blev slettet',
  'clo.taxOtherSaveFailed': 'Kunne ikke gemme andre oplysninger.',
  'clo.ownerBenefitsSaved': 'Ydelser gemt',
  'clo.companyInfoSaved': 'Selskabsoplysninger gemt',
  'clo.soleTraderChecksSaved': 'ENK-kontrollerne er gemt',
  'clo.taxSettlementSaved': 'Skatteopgørelsen er gemt',
  'clo.investmentSaved': '{{title}} gemt',
  'clo.investmentFallback': 'Investering',
  'clo.investmentDeleted': 'Investeringen blev slettet',
  'clo.incomeBalanceSaveFailed': 'Kunne ikke gemme resultatopgørelse og balance.',
  'clo.enterAccountBeforeSaving': 'Indtast kontonummer og kontonavn, før du gemmer posten.',
  'clo.entrySaved': 'Post gemt',
  'clo.entryDeletedShort': 'Post slettet',
  'clo.specificationSaved': 'Specifikation gemt',
  'clo.specificationDeleted': 'Specifikation slettet',
  'clo.detailedPayrollSpecDeleted': 'Detaljeret lønspecifikation slettet',
  'clo.equityChangeSaved': 'Egenkapitalændring gemt',
  'clo.equityChangeDeleted': 'Egenkapitalændring slettet',
  'clo.principleChangeSaved': 'Principændring gemt',
  'clo.principleChangeDeleted': 'Principændring slettet',
  'clo.draftMissingControls': 'Udkastet mangler {{count}} obligatoriske kontroller. Se advarslen øverst, og udfyld felterne, før du går videre.',
  'clo.dividendPaidInYear': 'Udbytte, der blev vedtaget og udbetalt i løbet af {{year}}',
  'clo.companyToOwnerBenefit': 'Har selskabet ydet lån, stillet sikkerhed, solgt eller udlejet til ejer eller nærtstående?',
  'clo.ownerToCompanyBenefit': 'Har ejer eller nærtstående ydet lån, stillet sikkerhed, solgt eller udlejet til selskabet?',
  'clo.loansToOwnerAmount': 'Udestående lån eller ydelser fra selskabet til ejeren',
  'clo.loansFromOwnerAmount': 'Udestående lån fra ejeren til selskabet',
  'clo.securityAmount': 'Sikkerhedsstillelser for ejer eller nærtstående',
  'clo.noteField': 'Note',
  'clo.industryRegime': 'Branche og særordning',
  'clo.industryRegimeOrdinary': 'Almindelig virksomhed',
  'clo.industryRegimeAgricultureForestry': 'Landbrug eller skovbrug – kræver faglig behandling',
  'clo.industryRegimeRegulatedFinance': 'Reguleret finansiel virksomhed – kræver faglig behandling',
  'clo.industryRegimeOtherSpecial': 'Anden særordning – kræver faglig behandling',
  'clo.financeTaxApplicability': 'Er selskabet omfattet af finansskat',
  'clo.financeTaxNotApplicable': 'Nej',
  'clo.financeTaxApplicable': 'Ja – kræver faglig behandling',
  'clo.financeTaxUnknown': 'Ikke afklaret',
  'clo.ownsProperty': 'Ejede selskabet fast ejendom ved årets udgang',
  'clo.propertyTaxValue': 'Samlet skattemæssig værdi af fast ejendom',
  'clo.propertyDetails': 'Ejendom – adresse, type og værdiansættelsesgrundlag',
  'clo.groupReceivablesAmount': 'Tilgodehavender hos koncernselskaber',
  'clo.groupDebtAmount': 'Gæld til koncernselskaber',
  'clo.groupDetails': 'Koncernposter og modparter',
  'clo.businessIncomeReviewed': 'Erhvervsindkomsten er kontrolleret mod regnskabet',
  'clo.otherPersonalIncomeReviewed': 'Anden indkomst og fradrag i den personlige skattemelding er kontrolleret',
  'clo.personalReturnReviewed': 'Den personlige skattemelding skal kontrolleres sammen med næringsspesifikasjonen',
  'clo.duplicateIncomeChecked': 'Samme indkomst eller fradrag er ikke medtaget både privat og i virksomheden',
  'clo.spouseAllocationStatus': 'Fordeling med ægtefælle',
  'clo.spouseAllocationNotApplicable': 'Ikke relevant',
  'clo.spouseAllocationReviewed': 'Fordelingen er vurderet og dokumenteret',
  'clo.spouseAllocationRequiresReview': 'Skal afklares med bogholder',
  'clo.spouseShareAmount': 'Beløb fordelt til ægtefælle',
  'clo.spouseAllocationBasis': 'Grundlag for fordelingen',
  'clo.advanceTaxPaid': 'Ordinær forskudsskat indbetalt',
  'clo.additionalAdvanceTax': 'Ekstra forskudsskat indbetalt',
  'clo.taxSettlementStatus': 'Status for skatteopgørelsen',
  'clo.taxSettlementPending': 'Ikke modtaget',
  'clo.taxSettlementReceived': 'Modtaget – ikke færdigbogført',
  'clo.taxSettlementSettled': 'Kontrolleret og bogført',
  'clo.finalAssessedTax': 'Fastsat skat i skatteopgørelsen',
  'clo.interestIncome': 'Renteindtægt i opgørelsen',
  'clo.interestExpense': 'Renteudgift i opgørelsen',
  'clo.settlementDate': 'Dato for skatteopgørelsen',
  'clo.settlementNotesOrRef': 'Note eller dokumentreference',
  'clo.noBalanceOnRelevantAccounts': 'Ingen saldo på relevante konti.',
  'clo.submissionAndCompany': 'Indsendelse og virksomhed',
  'clo.statusReady': 'Klar',
  'clo.statusMissingInfo': 'Mangler info',
  'clo.statusControl': 'Kontrollér',
  'clo.statusNoItems': 'Ingen poster',
  'clo.statusDiscrepancy': 'Afvigelse',
  'clo.objectsCount': '{{count}} objekter',
  'clo.investmentsCount': '{{count}} investeringer',
  'clo.company': 'Virksomhed',
  'clo.orgNumber': 'Organisationsnummer',
  'clo.taxAssetsCard': 'Aktiver',
  'clo.otherInfoCard': 'Andre oplysninger',
  'clo.incomeBalanceCard': 'Resultatopgørelse og balance',
  'clo.balanceDeviation': 'Balanceafvigelse',
  'clo.dividend': 'Udbytte',
  'clo.companyToOwnerShort': 'Selskab til ejer',
  'clo.ownerToCompanyShort': 'Ejer til selskab',
  'clo.investmentsShort': 'Investeringer',
  'clo.operatingIncomeShort': 'Driftsindtægt',
  'clo.annualResultShort': 'Årets resultat',
  'clo.totalAssetsShort': 'Aktiver i alt',
  'clo.added': 'Tilføjet',
  'clo.noSharesOrInvestmentsInTrialBalance': 'Ingen aktie- eller investeringsposter fundet i saldobalancen.',
  'clo.debtRelatedTo': 'Gæld relateret til',
  'clo.valueColumn': 'Værdi',
  'clo.noDebtItemsInTrialBalance': 'Ingen gældsposter fundet i saldobalancen.',
  'clo.prepareTaxBeforeClosing': 'Forbered skat, før året lukkes',
  'clo.prepareTaxBeforeClosingBody': 'Gennemgå skattegrundlaget nu. Plumme bruger det godkendte grundlag til at postere betalbar skat, når årsafslutningen lukkes. Selve indsendelsen er spærret indtil efter lukningen.',
  'clo.taxReturnTitle': 'Skattemelding {{year}}',
  'clo.taxReturnIntro': 'Skattemeldingen består af oplysninger fra regnskabet. Senere henter vi tal direkte fra Skatteetaten og Altinn — indtil videre opretter vi et lokalt udkast med de tal, du allerede har bogført.',
  'clo.netBusinessIncome': 'Netto erhvervsindkomst',
  'clo.mustBeClarified': 'Skal afklares',
  'clo.includedInPersonalTaxReturn': 'Indgår i indehaverens personlige skattemelding',
  'clo.mustBePaid': 'Skal betales',
  'clo.noCalculatedTaxInDraft': 'Ingen beregnet skat i udkastet',
  'clo.noRateApplied': 'Der er ikke anvendt nogen sats',
  'clo.taxCalcRequiresReview': 'Skatteberegningen kræver faglig afklaring',
  'clo.taxCalcRequiresReviewBody': 'Regnskabstallene kan gennemgås, men skat til betaling beregnes ikke, før branche, finansskat og øvrigt skatteregime er afklaret.',
  'clo.taxReturnNotReadyYet': 'Skattemeldingen er ikke klar endnu.',
  'clo.mandatoryChecksMissing': '{{count}} obligatoriske kontroller mangler. Gennemgå især skattegrundlag og andre oplysninger.',
  'clo.taxReturnInternallyReviewed': 'Udkastet er gennemgået internt. Det er ikke valideret af Skatteetaten.',
  'clo.draftForCompany': 'Udkast for {{company}}. Gennemgå hvert trin, og bekræft tallene.',
  'clo.theBusinessFallback': 'virksomheden',
  'clo.reviewDone': 'Færdig med gennemgang',
  'clo.continueLabel': 'Gå videre',
  'clo.taxCalculatedForYear': 'Beregnet skat for regnskabsåret {{year}}',
  'clo.notCalculated': 'Ikke beregnet',
  'clo.noAdditionsRegistered': 'Ingen tillæg registreret',
  'clo.noDeductionsRegistered': 'Ingen fradrag registreret',
  'clo.calculatedFromAccountCannotEdit': 'Beregnes ud fra konto {{code}} og kan ikke redigeres her.',
  'clo.calculatedFromAssetRegisterCannotEdit': 'Beregnes ud fra aktivregistret og kan ikke redigeres her.',
  'clo.missingPriorTaxYear': 'Vi mangler et tidligere skatteår at kontrollere mod. Åbn beløbet ovenfor, og gem 0, hvis der ikke er fremførbart underskud.',
  'clo.sumWealthAndDebtAtYearEnd': 'Formue og gæld i alt pr. 31.12.{{year}}',
  'clo.limitedCompanyNoNegativeWealth': 'Et aktieselskab kan ikke have negativ nettoformue. Derfor indberettes 0 kr i formue for dette selskab, selv om "Formue og gæld i alt" er negativ.',
  'clo.noFixedAssetsRegisteredForYear': 'Ingen anlægsaktiver eller gevinst-/tabskonti registreret for {{year}}.',
  'clo.personalTaxReturnAndBusinessIncome': 'Personlig skattemelding og erhvervsindkomst',
  'clo.personalTaxReturnAndBusinessIncomeBody': 'En ENK er ikke et selvstændigt skattesubjekt. Kontrollér erhvervsindkomsten sammen med øvrige personlige indkomster, fradrag og formue, og undgå, at samme beløb indberettes både privat og i virksomheden.',
  'clo.businessIncomeFromDraft': 'Erhvervsindkomst fra udkastet',
  'clo.personalTaxReturnChecked': 'Personlig skattemelding kontrolleret',
  'clo.spouseAllocationDetailStatus': 'Fordeling med ægtefælle',
  'clo.spouseAllocationReviewedShort': 'Vurderet',
  'clo.duplicateIncomeCheckedLabel': 'Dobbeltindberetning kontrolleret',
  'clo.fillInChecks': 'Udfyld kontrollerne',
  'clo.enkPersonalTaxReturnTitle': 'ENK – personlig skattemelding og erhvervsindkomst',
  'clo.ownerBenefitsBetweenCompanyAndOwnerTitle': 'Ydelser mellem selskabet og den personlige ejer',
  'clo.otherCompanyInfoTitle': 'Andre oplysninger om selskabet',
  'clo.advanceTaxAndSettlementTitle': 'Forskudsskat og skatteopgørelse',
  'clo.note': 'Notat',
  'clo.advanceTaxAndSettlement': 'Forskudsskat og skatteopgørelse',
  'clo.advanceTaxAndSettlementBody': 'Registrer indbetalt forskudsskat, når skattemeldingen klargøres. Når skatteopgørelsen kommer, kontrolleres fastsat skat, renter og eventuel restskat eller overskydende skat før bogføring.',
  'clo.advancePlusAdditionalPaid': 'Indbetalt forskudsskat og ekstra forskudsskat',
  'clo.estimatedDifferenceVsCalculatedTax': 'Estimeret difference mod beregnet skat',
  'clo.settlementStatusLabel': 'Status',
  'clo.settlementReceivedShort': 'Modtaget',
  'clo.settlementNotReceivedShort': 'Ikke modtaget',
  'clo.updateSettlement': 'Opdater opgørelsen',
  'clo.fillSharesInfoBody': 'Indberet aktier, fonde, obligationer, virtuel valuta og andre finansielle instrumenter, som selskabet ejer. Poster fra saldobalancen vises automatisk som forslag.',
  'clo.noSharesOrInvestmentsFound': 'Ingen aktier eller investeringer fundet i saldobalancen. Tilføj manuelle oplysninger, hvis selskabet ejer den slags poster.',
  'clo.sumSalesIncome': 'Salgsindtægter i alt',
  'clo.sumOtherOperatingIncome': 'Andre driftsindtægter i alt',
  'clo.sumGoodsCost': 'Vareforbrug i alt',
  'clo.sumPayrollCost': 'Lønomkostninger i alt',
  'clo.sumDepreciation': 'Afskrivninger i alt',
  'clo.sumOtherOperatingCost': 'Andre driftsomkostninger i alt',
  'clo.sumFinanceIncome': 'Finansielle indtægter i alt',
  'clo.sumFinanceCost': 'Finansielle omkostninger i alt',
  'clo.balanceDiscrepancyWithAmount': 'Balanceafvigelse: {{amount}}. Kontrollér saldobalancen før indsendelse.',
  'clo.inventoryValueTitle': 'Værdi af varelager',
  'clo.receivableTaxValueTitle': 'Skattemæssig værdi af tilgodehavender',
  'clo.payrollPensionSpecTitle': 'Specifikation af løn- og pensionsomkostninger',
  'clo.incomeKind': 'Indtægt',
  'clo.costKind': 'Omkostning',
  'clo.balanceKind': 'Balance',
  'clo.balanceDiscrepancyBody': 'Aktiver og egenkapital/gæld afviger med {{amount}}. Ret afvigelsen i bogføringen, før skattemeldingen kontrolleres til indsendelse.',
  'clo.detailsFallback': 'Detaljer',
  'clo.reviewStepsIntro': 'Gennemgå trinnene til venstre. Når alt er bekræftet, kan udkastet kontrolleres til indsendelse.',
  'clo.internalRulesOnly': 'Udkastet er kun kontrolleret mod Plummes interne regler. Officiel validering og indsendelse hos Skatteetaten er ikke forbundet.',
  'clo.processingStepPlaceholder': 'Vi viser dette som et behandlingstrin indtil videre. Når en rigtig integration kommer, hentes status fra Skatteetaten.',
  'clo.netWealthLabel': 'Nettoformue',
});
